import * as React from "react";
import area from "@turf/area";
import "./Map.scss";

function ControlPanel(props) {
  const polygon = props.polygon;
  const polygonArea = polygon && area(polygon);
  return (
    <div className="control-panel">
      {polygon ? (
        <div className="text-box">
          <h3>مساحت زمین</h3>
          <p>
            {(polygonArea / 10000).toFixed(4)} <br />
            هکتار
          </p>
        </div>
      ) : (
        <h3>زمین خود را مشخص کنید</h3>
      )}
    </div>
  );
}

export default React.memo(ControlPanel);
